import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tweet16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_479)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.8312 2.45617L1.83085 2.45735C1.67635 2.99015 1.62553 3.56427 1.63448 4.11551C1.64359 4.67616 1.73291 5.35262 2.01372 6.02334H0.888828C0.355178 6.02334 -0.0134598 6.59124 0.203793 7.07867C0.628301 8.03109 1.27747 8.86634 2.09563 9.51281C2.52627 9.85308 2.99696 10.1357 3.49567 10.3552C2.87371 10.7874 2.1931 11.1326 1.47253 11.3793C0.894785 11.5772 0.792741 12.3786 1.30248 12.7149C2.65633 13.6081 4.24271 14.0839 5.86461 14.0833C6.93778 14.0894 8.00165 13.8841 8.99548 13.4791C9.99008 13.0737 10.895 12.4763 11.6586 11.7209C12.4221 10.9656 13.0293 10.0671 13.4453 9.07693C13.8614 8.08675 14.0781 7.02427 14.0833 5.95025V5.22221L15.9999 2.66667L13.5101 3.28914C12.3774 1.64802 9.95768 1.43512 8.55414 2.83865C8.12948 3.26332 7.83491 3.79377 7.69611 4.36807C6.90795 4.31873 6.13207 4.13779 5.40108 3.83138C4.53682 3.41553 3.75539 2.8459 3.09496 2.15028C2.70402 1.7385 1.99056 1.91119 1.8312 2.45617ZM9.6148 3.89931C10.2845 3.2296 11.4043 3.2296 12.074 3.89931C12.4001 4.22542 12.5833 4.66771 12.5833 5.12889V5.94484C12.5789 6.82113 12.4019 7.68798 12.0624 8.49587C11.7227 9.30431 11.227 10.0379 10.6036 10.6546C9.98024 11.2713 9.2414 11.7591 8.42935 12.09C7.61731 12.421 6.74799 12.5886 5.87111 12.5834L5.8661 12.5833C5.03756 12.5839 4.2203 12.4326 3.4535 12.1412C4.22067 11.7236 4.93015 11.2032 5.56146 10.5923C5.99038 10.1773 5.76511 9.42657 5.17856 9.31626C4.39219 9.16836 3.65341 8.83195 3.02559 8.33588C2.72284 8.09666 2.45025 7.82376 2.2126 7.52334H3.37772C4.02125 7.52334 4.36493 6.72826 3.92404 6.2595C3.35516 5.65465 3.1643 4.88744 3.13717 4.19561C3.64501 4.58158 4.19182 4.91569 4.76959 5.19211C4.78015 5.19717 4.79083 5.20198 4.80163 5.20653C5.93146 5.68341 7.15039 5.91259 8.37628 5.8786C8.78224 5.86735 9.10549 5.53501 9.10549 5.12889C9.10549 4.66771 9.2887 4.22542 9.6148 3.89931Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_479'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Tweet16.displayName = 'Tweet16';
export default Tweet16;
